export function useFindUserDeviceType(): string | null {
  const userAgent = window.navigator.userAgent;
  let os: null | string = null;

  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    os = "iOS";
  } else if (userAgent.match(/Android/i)) {
    os = "Android";
  }

  return os;
}
